import { render, staticRenderFns } from "./DetailOrderHistory.vue?vue&type=template&id=0e06068b"
import script from "./DetailOrderHistory.vue?vue&type=script&lang=js"
export * from "./DetailOrderHistory.vue?vue&type=script&lang=js"
import style0 from "./DetailOrderHistory.vue?vue&type=style&index=0&id=0e06068b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports